import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { StateService } from '../state/state.service';

@Injectable({
  providedIn: 'root',
})
export class GtmService {
  constructor(
    private stateService: StateService,
    private gtmService: GoogleTagManagerService
  ) {}

  public async emitPageViewEvent(path: string): Promise<void> {
    if (!this.isAcceptedAnalysisAndStatistics()) {
      return;
    }

    try {
      const gtmTag = {
        event: 'CustomPageViewEvent',
        page_url: path,
      };

      await this.gtmService.pushTag(gtmTag);
    } catch (e) {
      console.error(e);
    }
  }

  public async emitOnlineBookingFeatureRequestByCustomerEvent(
    placeId: string,
    customerEmail: string
  ): Promise<void> {
    if (!this.isAcceptedAnalysisAndStatistics()) {
      return;
    }

    try {
      const gtmTag = {
        event: 'OnlineBookingFeatureRequestByCustomer',
        customer_email: customerEmail,
        place_id: placeId,
      };

      await this.gtmService.pushTag(gtmTag);
    } catch (e) {
      console.error(e);
    }
  }

  public async emitBranchLogoClickEvent(path: string): Promise<void> {
    if (!this.isAcceptedAnalysisAndStatistics()) {
      return;
    }

    try {
      const gtmTag = {
        event: 'BranchLogoClickEvent',
        page_url: path,
      };

      await this.gtmService.pushTag(gtmTag);
    } catch (e) {
      console.error(e);
    }
  }

  private isAcceptedAnalysisAndStatistics(): boolean {
    return !!this.stateService.getCookiesConfig()?.analysisAndStatistics;
  }
}
